'use strict'

module.exports = [
  require('./visa'),
  require('./maestro'),
  require('./forbrugsforeningen'),
  require('./dankort'),
  require('./mastercard'),
  require('./american-express'),
  require('./diners-club'),
  require('./discover'),
  require('./jcb'),
  require('./unionpay'),
  require('./troy'),
  require('./elo'),
  require('./uatp')
]
